import {Store, Module, ActionContext, GetterTree, MutationTree} from 'vuex'
import Ajax from '@/lib/ajax'

interface CorrespondenceState {
    correspondence: any,
}

class CorrespondenceModule {
    namespaced = true;
    state = {
        correspondence: null,
    };
    mutations = {
        setCorrespondence(state: CorrespondenceState, page: any) {
            state.correspondence = page;
        },
    };
    actions = {
        async getCorrespondenceUserSearch(context: ActionContext<CorrespondenceState, any>, payload: any) {

            let response: any = await Ajax.get(
                `/api/services/app/Correspondence/GetCorrespondenceUserSearch`,
                {params: payload.data});
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async processCorrespondence(context: ActionContext<CorrespondenceState, any>, payload: any) {
            const data = payload.data;
            let response: any = await Ajax.post(
                `/api/services/app/Correspondence/ProcessCorrespondence`, data);
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async setNotificationAsRead(context: ActionContext<CorrespondenceState, any>, payload: any) {
            let response: any = await Ajax.post(
                `/api/services/app/Notification/SetNotificationAsRead`, payload.data);

            return response
        },
        async setAllNotificationsAsRead(context: ActionContext<CorrespondenceState, any>, payload: any) {
            let response: any = await Ajax.post(
                `/api/services/app/Notification/SetAllNotificationsAsRead`);

            return response
        },
        async markAsAchrived(context: ActionContext<CorrespondenceState, any>, payload: any) {
            const data = payload.data;
            let response: any = await Ajax.post(
                `/api/services/app/Correspondence/MarkAsAchrived`, data);
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async markAsUnarchived(context: ActionContext<CorrespondenceState, any>, payload: any) {
            const data = payload.data;
            let response: any = await Ajax.post(
                `/api/services/app/Correspondence/MarkAsUnachrived`, data);
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async markAsUnread(context: ActionContext<CorrespondenceState, any>, payload: any) {
            const data = payload.data;
            let response: any = await Ajax.post(
                `/api/services/app/Correspondence/MarkAsUnread`, data);
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async markAsRead(context: ActionContext<CorrespondenceState, any>, payload: any) {
            const data = payload.data;
            let response: any = await Ajax.post(
                `/api/services/app/Correspondence/MarkAsRead`, data);
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async getCorrespondencesView(context: ActionContext<CorrespondenceState, any>, payload: any) {
            let response: any = await Ajax.get(
                `/api/services/app/Correspondence/GetCorrespondencesView`,
                {params: payload.data.Filter ? payload.data : null});
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async getCorrespondencesViewArchive(context: ActionContext<CorrespondenceState, any>, payload: any) {
            let response: any = await Ajax.get(
                `/api/services/app/Correspondence/GetCorrespondencesViewArchive`,
                {params: payload.data});
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async getCorrespondencesUploadArchive(context: ActionContext<CorrespondenceState, any>, payload: any) {
            let response: any = await Ajax.get(
                `/api/services/app/Correspondence/GetCorrespondencesUploadArchive`,
                {params: payload.data.Filter ? payload.data : null});
            const result = response && response.data && response.data ? response.data.result : null;
            return result
        },
        async getCorrespondencesUpload(context: ActionContext<CorrespondenceState, any>, payload: any) {
            let response: any = await Ajax.get(
                `/api/services/app/Correspondence/GetCorrespondencesUpload`,
                {params: payload.data.Filter ? payload.data : null});
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async uploadCorrespondence(context: ActionContext<CorrespondenceState, any>, payload: any) {
            const data = payload.data;
            let response: any = await Ajax.post(
                `/api/services/app/Correspondence/UploadCorrespondence`, data);
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        async createNewFileNum(context: ActionContext<CorrespondenceState, any>, payload: any) {
            const data = payload.data;
            let response: any = await Ajax.put(
                `/api/services/app/Correspondence/CreateNewFileNum`, data);
            const result = response && response.data && response.data.result ? response.data.result : null;
            return result
        },
        // Actions moved from "app" store module.
    async signUpForVPostalBox(content: ActionContext<CorrespondenceState, any>) {
        let rep = await Ajax.post("/api/services/app/Correspondence/SignUpForVPostalBox")
        return rep
      },
  
      async removeVPostalBox(content: ActionContext<CorrespondenceState, any>) {
        let rep = await Ajax.delete("/api/services/app/Correspondence/RemoveVPostalBox")
        return rep
      },
    };

}

export default new CorrespondenceModule();